export const tokens = {
  colors: {
    light: {
      primary: {
        main: '#00B6C9',
        light: '#4CB4E3',
        dark: '#0276A6',
        contrastText: '#FFFFFF',
      },
      secondary: {
        main: '#8DC63F',
        light: '#A7D465',
        dark: '#6C9830',
        contrastText: '#FFFFFF',
      },
      gradient: {
        primary: 'linear-gradient(90deg, #00BFA6 0%, #0288D1 100%)',
      },
      success: {
        main: '#2E7D32',
        light: '#4CAF50',
        dark: '#1B5E20',
        contrastText: '#FFFFFF',
      },
      warning: {
        main: '#ED6C02',
        light: '#FF9800',
        dark: '#C77700',
        contrastText: '#FFFFFF',
      },
      error: {
        main: '#D32F2F',
        light: '#EF5350',
        dark: '#C62828',
        contrastText: '#FFFFFF',
      },
      info: {
        main: '#0288D1',
        light: '#03A9F4',
        dark: '#01579B',
        contrastText: '#FFFFFF',
      },
      neutral: {
        main: '#64748B',
        light: '#94A3B8',
        dark: '#475569',
        contrastText: '#FFFFFF',
      },
      text: {
        /* this will be consolidated at last as primary/secondary once everything is fixed - starts */
        headerPrimary: '#333333',
        headerSecondary: '#8A8A8A',
        /* this will be consolidated at last as primary/secondary once everything is fixed - ends */
        primary: '#1A202C',
        secondary: '#4A5568',
        disabled: '#A0AEC0',
      },
      divider: 'rgba(0, 0, 0, 0.12)',
      background: {
        paper: '#FFFFFF',
        default: '#F7FAFC',
      },
    },
    dark: {
      primary: {
        main: '#00B6C9',
        light: '#7CCAEC',
        dark: '#029AD8',
        contrastText: '#FFFFFF',
      },
      gradient: {
        primary: 'linear-gradient(90deg, #00BFA6 0%, #0288D1 100%)',
      },
      secondary: {
        main: '#8DC63F',
        light: '#BFE088',
        dark: '#8DC73F',
        contrastText: '#FFFFFF',
      },
      success: {
        main: '#4CAF50',
        light: '#81C784',
        dark: '#388E3C',
        contrastText: '#FFFFFF',
      },
      warning: {
        main: '#FF9800',
        light: '#FFB74D',
        dark: '#F57C00',
        contrastText: '#FFFFFF',
      },
      error: {
        main: '#EF5350',
        light: '#E57373',
        dark: '#D32F2F',
        contrastText: '#FFFFFF',
      },
      info: {
        main: '#03A9F4',
        light: '#4FC3F7',
        dark: '#0288D1',
        contrastText: '#FFFFFF',
      },
      neutral: {
        main: '#94A3B8',
        light: '#CBD5E1',
        dark: '#64748B',
        contrastText: '#FFFFFF',
      },
      text: {
        primary: '#F7FAFC',
        secondary: '#CBD5E1',
        disabled: '#64748B',
      },
      divider: 'rgba(255, 255, 255, 0.12)',
      background: {
        paper: '#1A202C',
        default: '#252525',
      },
    },
    common: {
      white: '#FFFFFF',
      gradient: {
        primary: 'linear-gradient(90deg, #8DC73F 0%, #029AD8 100%)',
      },
      overlay: {
        light: {
          card: 'rgba(255, 255, 255, 0.9)',
          surfaceLight: 'rgba(255, 255, 255, 0.7)',
          surfaceMedium: 'rgba(255, 255, 255, 0.5)',
          surfaceStrong: 'rgba(255, 255, 255, 0.3)',
        },
        dark: {
          card: 'rgba(0, 0, 0, 0.3)',
          surfaceLight: 'rgba(0, 0, 0, 0.1)',
          surfaceMedium: 'rgba(0, 0, 0, 0.3)',
          surfaceStrong: 'rgba(0, 0, 0, 0.5)',
        },
      },
    },
  },

  // Standard animation values
  animation: {
    durations: {
      shortest: 150,
      shorter: 200,
      short: 250,
      standard: 300,
      complex: 375,
      entering: 225,
      leaving: 195,
    },
    easings: {
      easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
      easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
      easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
      sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
      bounce: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)',
    },
    // Predefined transition strings using the durations and easings
    transitions: {
      color: '200ms cubic-bezier(0.4, 0, 0.2, 1)',
      backgroundColor: '200ms cubic-bezier(0.4, 0, 0.2, 1)',
      border: '200ms cubic-bezier(0.4, 0, 0.2, 1)',
      boxShadow: '200ms cubic-bezier(0.4, 0, 0.2, 1)',
      transform: '200ms cubic-bezier(0.4, 0, 0.2, 1)',
      opacity: '200ms cubic-bezier(0.4, 0, 0.2, 1)',
      width: '300ms cubic-bezier(0.4, 0, 0.2, 1)',
      all: '300ms cubic-bezier(0.4, 0, 0.2, 1)',
    },
  },
} as const
